import React, { useContext } from "react";
import embLabels from "../../config/emb-labels-en.json";
import ACTIONS from "./Design_Asset_Actions.json";
import Tooltip from "../../utils/Tooltip";

import { AssetBlockContext } from "../CustomHooks/ContextApi";

const UtilityAsset = () => {
  const {
    CBAssetList = [],
    siteType,
    clientType,
    architectureType,
    gsxExternalId,
    configData,
    defaultsMinMax,
    handleUtilityChange,
    updateUtilitytConfig,
    calculateMaxAvailableUtilityPower,
    CBAssetListDispatch,
    selectedValues,
    defaultCbData,
    handleCbAssetRequired,
    handlePmAssetRequired,
    projectKind,
  } = useContext(AssetBlockContext);
  if(!configData?.configData) {
    return null;
  }
  const utilityChangeHandler = e => {
    handleUtilityChange(e);
  };
  const utilityUpdateHandler = e => updateUtilitytConfig(e);
  const isPowerMeterRequired = ()=> projectKind?.isMgaasAnsi;
  const [powerIsBetween, nominalPowerMin, nominalPowerMax] =
    calculateMaxAvailableUtilityPower();
  return (
    <div name="utility" className="col-md-12 p-0">
      <div className="col-md-12 pt-2 pl-0 se-white-background">
        <div className="col-md-12 pb-2 se-white-background ">
          <se-icon
            color="primary"
            className="se-icon icon_button se-life-green"
            size="medium"
          >
            segment_energy_infrastructure
          </se-icon>
          <span className="ml-2 bold">Utility</span>
        </div>
      </div>

      <div className="col-md-12 mt-1 mb-1 se-white-background align-middle se-border">
        <div className="row">
          <label className=" col-md-5 bold mt-2 mb-2 pl-2 se-font-14px">
            Asset Settings
          </label>
          <div className="col-md-7 mt-1 text-right">
            <button
              type="button"
              className="btn btn-sm se-btn-secondary"
              onClick={utilityUpdateHandler}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save Settings
            </button>
          </div>
        </div>

        
      </div>
      <div className="col-md-12 pt-2 pb-2 se-grey-background">
                  {/* Commenting because for future Int in Daas ANSI */}

      {isPowerMeterRequired()&& (
          <div className="form-group mb-1">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input asCompatible"
                    name="pmRequired"
                    id="pmRequiredValidation"
                    
                    onChange={()=>handlePmAssetRequired(selectedValues.selectedAsset)}
                    value={
                      CBAssetList[selectedValues.selectedAsset].uiData.pmRequired
                    }
                    checked={
                      CBAssetList[selectedValues.selectedAsset].uiData.pmRequired
                    }
                  />
                  <label
                    className="custom-control-label line-height-25"
                    htmlFor="pmRequiredValidation"
                  >
                    Enable resource energy monitoring
                  </label>
                  <Tooltip
                    position="left"
                    iconColor="secondary"
                    iconSize="small"
                    information="Once selected, a power meter will be added to this branch to allow accurate metering, or specific sub metering function"
                  /> 
                </div>
            {/* {(
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  clientType === embLabels.GREENSTRUXURE_PROJECT &&
                  projectTypeValue?.projectTypeValue === "DaaS ANSI")) && (
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input asCompatible"
                    name="cBRequired"
                    id="cBRequiredValidation"
                    onChange={()=>handleCbAssetRequired(selectedValues.selectedAsset) }
                    value={
                      CBAssetList[selectedValues.selectedAsset].uiData.cbRequired
                    }
                    checked={
                      CBAssetList[selectedValues.selectedAsset].uiData.cbRequired
                    }
                  />
                  <label
                    className="custom-control-label line-height-25"
                    htmlFor="cBRequiredValidation"
                  >
                    Enable breaker control
                  </label>
                  <Tooltip
                    position="left"
                    iconColor="secondary"
                    iconSize="small"
                    information="Select this option to allow manual branch operation via EMO-M HMI."
                  />
                </div>
              )} */}
          </div>
        )}
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm inputFocus"}
            id="exampleFormControlInput1"
            name="name"
            maxLength="50"
            value={configData?.configData?.name}
            onChange={utilityChangeHandler}
            placeholder="Name"
          />
          <div
            className="invalid-feedback-custom"
            style={!configData?.configData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
          <div
            className="invalid-feedback-custom"
            style={configData?.configData?.name !==""  && !/^[a-zA-Z0-9-_ ]+$/.test(configData?.configData?.name )? {} : { display: "none" }}
          >
            {embLabels.notallowedAlphanumericValues}
          </div>
        </div>
        {[embLabels.ISLANDABLE_GSX, embLabels.GRID_CONNECTED_GSX].includes(siteType) &&
          (architectureType === embLabels.PV_GENSET_ATS || architectureType === embLabels.PV_BESS_NR) && (
            <div className="form-group mb-1">
              <label htmlFor="exampleFormControlInput1">External ID</label>
              <input
                type="text"
                autoComplete="none"
                className="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="External ID"
                onChange={utilityChangeHandler}
                name="externalId"
                maxLength="64"
                value={gsxExternalId.utilityExternalId}
              />
            </div>
          )}

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            onChange={utilityChangeHandler}
            name="description"
            maxLength="100"
            value={configData?.configData?.description}
          />
        </div>

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput2">
            Maximum Available Power (kW) <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput2"
            name="maximum_available_power"
            maxLength="8"
            value={configData?.configData?.maximum_available_power}
            onChange={utilityChangeHandler}
            placeholder="Maximum Available Power (kW)"
          />
          {(configData?.configData?.maximum_available_power === "" ||(parseInt(configData?.configData?.maximum_available_power) === 0)) && (
            <div className="invalid-feedback-custom">
              Maximum Available Power (kW) is required.
            </div>
          )}
          {configData?.configData?.maximum_available_power !== "" &&
            !powerIsBetween ? (
            <div className="invalid-feedback-custom">
              Maximum Available Power should be in range( {nominalPowerMin} -
              {nominalPowerMax} kW).
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput2">
            Utility CO2 Emission Rate (g/kWh){" "}
            <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput2"
            name="utilityCO2"
            maxLength="4"
            value={configData?.configData?.utilityCO2}
            onChange={utilityChangeHandler}
            placeholder="Utility CO2 Emission Rate"
          />
          {configData?.configData?.utilityCO2 === "" && (
            <div className="invalid-feedback-custom">
              Utility CO2 Emission g/kWh is required.
            </div>
          )}

          {configData?.configData?.utilityCO2 !== "" &&
            (parseInt(configData?.configData?.utilityCO2) <
              defaultsMinMax.utilityCO2Min ||
              parseInt(configData?.configData?.utilityCO2) >
              defaultsMinMax.utilityCO2Max) && (
              <div className="invalid-feedback-custom">
                Utility CO2 Emission should be in range(
                {defaultsMinMax.utilityCO2Min} - {defaultsMinMax.utilityCO2Max}{" "}
                g/kWh).
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default UtilityAsset;

